define('plugin/package/controller/PackageController',['require','lib/controller/BaseController','lib/plugin/PluginBroker','plugin/package/view/PackageIndexLayout','plugin/package/view/PackageClientInstanceLayout','plugin/package/collection/PackageInstanceCollection','plugin/package/model/PackageOrderModel','Config'],function (require) {

    // base controller
    var BaseController = require('lib/controller/BaseController');
    var PluginBroker = require('lib/plugin/PluginBroker');

    // views
    var PackageIndexLayout = require('plugin/package/view/PackageIndexLayout');
    var PackageClientInstanceLayout = require('plugin/package/view/PackageClientInstanceLayout');

    // models
    var PackageInstanceCollection = require('plugin/package/collection/PackageInstanceCollection');
    var PackageOrderModel = require('plugin/package/model/PackageOrderModel');

    var Config = require('Config');

    /**
     * Package Controller
     *
     * @class PackageController
     */
    return BaseController.extend({

        _collection: null,
        _productCollection: null,
        _attributeCollection: null,
        _serviceCollection: null,

        _view: null,
        _message: null,

        initialize: function () {
            this._collection = this.getOption('collection');
            this._serviceCollection = this.getOption('serviceCollection');
            this._productCollection = this.getOption('productCollection');
            this._attributeCollection = this.getOption('attributeCollection');

            BaseController.prototype.initialize.call(this);
        },

        /**
         * index action, displays list of packages
         */
        index: function (id, services, products) {
            this._view = new PackageIndexLayout({
                collection: this._collection,
                serviceCollection: this._serviceCollection,
                productCollection: this._productCollection,
                attributeCollection: this._attributeCollection,
                filterData: {
                    id: id,
                    services: services,
                    products: products
                },
                withFilter: !id
            });

            this.getMainLayout().getContentRegion().show(this._view);

            if (this._message) {
                this._view.showErrorMessage(this._message);
                this._message = null;
            }

            this._collection.load();

            PluginBroker.getInstance().getPlugin('package').loadRelatedCollections();
        },


        /**
         * Displays clients packages info
         */
        my: function (id) {
            var collection = new PackageInstanceCollection();

            var view = new PackageClientInstanceLayout({
                collection: collection,
                serviceCollection: this._serviceCollection,
                productCollection: this._productCollection,
                attributeCollection: this._attributeCollection,
                highlighted: id
            });

            this.getMainLayout().getContentRegion().show(view);

            collection.getPager().setSkipPagination(true);
            collection.fetch({
                error: _.bind(function (model, xhr) {
                    var result = xhr.responseJSON;
                    if (result && result.login_client) {
                        this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('packages/my'));
                    }
                }, this)
            });
            PluginBroker.getInstance().getPlugin('package').loadRelatedCollections();
        },

        /**
         * Creates package order and redirect to payment or to sign up client.
         *
         * @param id
         * @param date
         */
        buy: function (id, date) {
            var model = new PackageOrderModel({
                package_id: id,
                start_date: date
            });
            model.save(null, {
                success: _.bind(function (model) {
                    if (model.get('invoice')) {
                        this._redirectWithReplace('invoice/pay/' + model.get('invoice').get('id'));
                    }
                }, this),
                error: _.bind(function (model, xhr) {
                    var result = xhr.responseJSON;
                    if (result && result.login_client) {
                        this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('package/buy/' + id + '/' + date));
                    } else {
                        var errorField = _.first(result.errors);
                        if (errorField && errorField.errors) {
                            this.showErrorMessage(_.first(errorField.errors));
                        }
                    }
                }, this)
            });
        },

        /**
         * Shows error message
         *
         * @param error
         */
        showErrorMessage: function (error) {
            if (!(this._view && !this._view.isDestroyed && this._view.showErrorMessage(error))) {
                this._message = error;
                this._redirect('packages');
            }
        }

    });

});
